/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useEffect, useState} from "react";


import {Col, Row, Form} from "react-bootstrap";


type CompartmentProductsProps = {
    compartmentPosition: any,
    compartmentCapacity: any,
    compartmentProducts: any;
    compartmentSelectedProduct?: any;
    compartmentModifyHandler: any;
    compartmentActiveProduct?: any;
    compartmentActiveProductHandler?: any;
    compartmentActiveProductCapacity?: any;
    compartmentActiveProductCapacityHandler?: any;
    editable?: boolean;
};


export const CompartmentProductsComponent: React.FC<CompartmentProductsProps> = ({
    compartmentActiveProduct, compartmentActiveProductHandler,
    compartmentActiveProductCapacity, compartmentActiveProductCapacityHandler,
    compartmentPosition, compartmentCapacity, compartmentProducts, compartmentSelectedProduct,
    compartmentModifyHandler, editable = true
}): JSX.Element | null => {    

    useEffect(() => {
        const HANDLER = (e: KeyboardEvent) => {
            for (let elem of Array.from(document.querySelectorAll("input"))) {
                if (e.key === "Enter") {
                    elem.blur();
                }
            }
        }
        document.addEventListener("keydown", HANDLER);
        return () => document.removeEventListener("keydown", HANDLER);
    }, []);


    if (!compartmentProducts) return null;


    const selectedProduct = compartmentActiveProduct ? compartmentProducts[compartmentActiveProduct] : {};

    const {
        // Qty: productQuantity,
        QtyAvail: productQuantity,
        productCompartments
    }: {Qty: number, QtyAvail: number, productCompartments: number[]} = selectedProduct || {};


    let usedProductCapacity = 0;

    if (productCompartments && Object.entries(productCompartments).length) {
        for (let usedCapacity of Object.entries(productCompartments)) {
            usedProductCapacity += +usedCapacity[1] || 0;
        }
    }

    const leftProductCapacity = productQuantity - usedProductCapacity;

    const compartmentMaximumProductLoad = compartmentCapacity > leftProductCapacity ? leftProductCapacity : compartmentCapacity;

    
    return (
        <Col xs={12} className={"monitory-note-compartment-products-choice"}>
            <Row className={"monitory-note-compartment-products-choice-content"}>

                <Col xs={8} className={"products-choice-field product-name"}>
                    <Form.Label>{`Produkt`}</Form.Label>
                    <Form.Control disabled={!editable} as={"select"} value={compartmentActiveProduct} onChange={compartmentActiveProductHandler}>
                        <option value={""}>{"wybierz"}</option>
                        {Object.entries(compartmentProducts).map(([productId, product]: any) => {
                            if (!product) return null;
                            const {QtyAvail: productQuantity, productCompartments}: {QtyAvail: any, productCompartments: number[]} = product;
                            let usedCapacity = 0;
                            if (productCompartments) {
                                for (let capacity of Object.values(productCompartments)) {
                                    usedCapacity += +capacity;
                                }
                            }
                            // console.log(productCompartments, usedCapacity);
                            const leftCapacity = productQuantity - usedCapacity;
                            // if (leftCapacity < 1) return null;
                            return (
                                <option disabled={leftCapacity < 1} key={productId} value={productId}>{product.DispNo} - {product.ProductShortName} ({leftCapacity} dm3 z {productQuantity} dm3)</option>
                            );
                        })}
                    </Form.Control>
                </Col>

                <Col xs={4} className={"products-choice-field product-capacity"}>
                    <Form.Label>{`Ilość [dm3]`}</Form.Label>
	                <Form.Control
                        type={"number"} pattern="[0-9]*" inputMode={"numeric"}
		                min={500} max={compartmentMaximumProductLoad}
		                value={compartmentActiveProductCapacity} onChange={compartmentActiveProductCapacityHandler}
                        disabled={!(compartmentActiveProduct && editable)}
	                />
                    <span className={"capacity-label"}>{`/`}{compartmentCapacity}</span>
                </Col>

            </Row>
        </Col>
    )

};


export default CompartmentProductsComponent;
